module.exports = __webpack_public_path__ + "static/nia-899c38037ad2ea4c8604862ae2251bd9.svg";